import {send} from 'ajax';
import {fb_track_lead} from 'third_party_custom_callbacks';
import {isUK} from 'international';
import {country} from 'international';
import {getCookie} from 'browser';

if (isUK()){
  document.getElementById('us_cell').innerHTML = '';
}
else {
  document.getElementById('uk_cell').innerHTML = '';
}

// Show/hide the send-to-type UI according to the selected type
// be sure to do this after adjustment for international
const santacell = document.getElementById('santacell');
const santaemail = document.getElementById('santaemail');

var approve_order = false;

var send_to_type = document.getElementById('order_send_to_type') ? document.getElementById('order_send_to_type') : document.getElementById('new_order_send_to_type');

send_to_type.addEventListener('change', (event) => {
  if (event.target.value === 'Cell Phone') {
    sendToCell();
  } else if (event.target.value === 'Email') {
    sendToEmail();
  }
});

// populate fb pixel information
document.getElementById('fbp').value = getCookie('_fbp');
document.getElementById('fbc').value = getCookie('_fbc');
document.getElementById('website').value = window.location.href; 


export function sendToCell(){
  santacell.className = 'santacell';
  santaemail.className = 'santaemail hidden';
}
export function sendToEmail(){
  santacell.className = 'santacell hidden';
  santaemail.className = 'santaemail';
}

var tel_area = document.getElementById('tel_area');
var tel_first = document.getElementById('tel_first');
var tel_second = document.getElementById('tel_second');
var uk_tel_first = document.getElementById('uk_tel_first');
var uk_tel_second = document.getElementById('uk_tel_second');
var order_name = document.getElementById('order_name');
var o_user_email = document.getElementById('order_user_email');


// US only
if (tel_area) {
  tel_area.addEventListener('keyup', (event) => {
    if (tel_area.value.length == 3) {
      tel_first.focus();
    }
  });
  tel_first.addEventListener('keyup', (event) => {
    if (tel_first.value.length == 3) {
      tel_second.focus();
    }
  });
  tel_second.addEventListener('keyup', (event) => {
    if (tel_second.value.length == 4) {
      o_user_email.focus();
    }
  });
}

if (uk_tel_first) {
  uk_tel_first.addEventListener('keyup', (event) => {
    if (uk_tel_first.value.length == 5) {
      uk_tel_second.focus();
    }
  });
  uk_tel_second.addEventListener('keyup', (event) => {
    if (uk_tel_second.value.length == 6) {
      order_name.focus();
    }
  });
}



// Handling order submission 
function validateOrderForm(){
   console.log('evaluating');
    var sendtotype = document.getElementById('order_send_to_type');
    var email_field = document.getElementById('order_email');
    var order_email = document.getElementById('order_user_email');
    if (sendtotype) {
      console.log('send to type is : ' + sendtotype.value);
      if (sendtotype.value == 'Email') {
         console.log('checking email');
        if (!email_field.value || email_field.value.replace(' ','').length == 0){
          email_field.classList = 'error';
          email_field.addEventListener('change', (event) => {email_field.classList = '';});
          location.href = '#';
          location.href = '#top_of_form'; 
          return false;
        }
      }
      if (sendtotype.value == 'Cell Phone') {
        if (isUK()) {
          if (!uk_tel_first.value || !uk_tel_second.value || (uk_tel_first.value.replace(' ','').length + uk_tel_second.value.replace(' ','').length != 11)){
            uk_tel_first.classList = 'tel_first error';
            uk_tel_second.classList = 'tel_second error';
            uk_tel_first.addEventListener('change', (event) => {uk_tel_first.classList ='tel_first'; uk_tel_second.classList = 'tel_second';});
            uk_tel_second.addEventListener('change', (event) => {uk_tel_first.classList ='tel_first'; uk_tel_second.classList = 'tel_second';});
            location.href = '#';
            location.href = '#top_of_form'; 
            return false; 
          }
        }
        else {
          console.log('checking cell phone');
          if (!tel_area.value || !tel_first.value || !tel_second.value || (tel_area.value.replace(' ','').length + tel_first.value.replace(' ','').length + tel_second.value.replace(' ','').length != 10)){
            tel_area.classList = 'tel_area error';
            tel_first.classList = 'tel_first error';
            tel_second.classList = 'tel_second error';
            tel_area.addEventListener('change', (event) => {tel_area.classList = 'tel_area'; tel_first.classList ='tel_first'; tel_second.classList = 'tel_second';});
            tel_first.addEventListener('change', (event) => {tel_area.classList = 'tel_area'; tel_first.classList ='tel_first'; tel_second.classList = 'tel_second';});
            tel_second.addEventListener('change', (event) => {tel_area.classList = 'tel_area'; tel_first.classList ='tel_first'; tel_second.classList = 'tel_second';});
            location.href = '#';
            location.href = '#top_of_form'; 
            console.log('cell phone fail');
            return false; 
          }
          else {
            console.log('cell phone pass');
          }
        }
      }
    }
    if (order_email){
      console.log('checking email');
      if (!order_email.value || order_email.value.replace(' ','').length == 0 ) {
        order_email.classList = 'error';
        order_email.addEventListener('change', (event) => {order_email.classList = '';});
        console.log('email fail');
        return false;
      }
      else {
        console.log('email pass');
      }
    }  
    return true;
}


// Add new Order page
var new_order_form = document.getElementById('santas_re_order');
var new_order_form_button = document.getElementById('add_new_child_button');
if (new_order_form){
  new_order_form_button.addEventListener('click', (event) => {
    if (validateOrderForm()){
      new_order_form.submit(); 
    }
  });
}

// Sign Up Page
if (document.getElementById('santas_order')) {
  // Validating order fields
  document.getElementById('santas_order').addEventListener('submit',   (event) => {
    console.log('form submitted');
    approve_order = validateOrderForm();
  });
  // Listening for the order's ajax submit 
  document.getElementById('santas_order').addEventListener('ajax:complete',   (event) => {
     console.log(event);
    const [xhr, status] = event.detail;
    let ot =  JSON.parse(xhr.response).ot;
    console.log('status is ' + status);
    if (status === '200' || status == 'OK' || status == '') {
      // Show the order page on successful submission
      send("GET", "/santa/store_user?country=" + country()); // want to run this async
      if (approve_order) {
        if (document.getElementById('elf_version_1')) {
          fb_track_lead(document.getElementById('order_user_email').value);
          Turbolinks.visit('/santa/text_details?ot=' + ot);
        }
        else {
            fb_track_lead(document.getElementById('order_user_email').value);
            Turbolinks.visit('/santa/text_packages');
        }
      }
    } else {
      console.log(`show an error message; rails said: ${status}` + ' status: |' + status + '|');
    }
  });
}

// Get order info if token is passed - used for back/edit 
(async () => {
  const o_token = document.getElementById('order_token');
  if (o_token && o_token.innerHTML.length > 3) {
    console.log("Santa detects a token async!");
    try {
      const order = await send("POST", "/santa/get_order_by_token", "ot=" + o_token.innerHTML);
      if (!order) {
        let error = 'No order found';
        //Turbolinks.visit('/santa/text?message=' + error);
      }
      document.getElementById('order_name').value = order.name; 
      document.getElementById('order_send_to_type').value = order.send_to_type;
      if (order.send_to_type == 'Cell Phone') {
        if (isUK()){
          document.getElementById('uk_tel_first').value = order.cell_phone.substring(0,5);
          document.getElementById('uk_tel_second').value = order.cell_phone.substring(6,12);
        }
        else {
          document.getElementById('tel_area').value = order.cell_phone.substring(1,4);
          document.getElementById('tel_first').value = order.cell_phone.substring(6,9);
          document.getElementById('tel_second').value = order.cell_phone.substring(10,14);
        }
        sendToCell();
      }
      if (order.send_to_type == 'Email') {
        document.getElementById('order_email').value = order.email;
        sendToEmail();
      }
      document.getElementById('order_gender').value = order.gender;
      document.getElementById('order_age').value = order.age;
      document.getElementById('order_town').value = order.town;
      document.getElementById('order_pet_name').value = order.pet_name;
      document.getElementById('order_pet_type').value = order.pet_type;
      document.getElementById('order_elf_name').value = order.elf_name;
      document.getElementById('order_user_email').value = order.user_email;
    }
    catch (err) {
      console.log('show order err: ' + err);
    }
  }
})();


//// For now, remove any previously-logged-in user from the session when this page loads
//(async () => {
//  try {
//    await send("POST", "/santa/clear_user");
//  }
//  catch (err) {
//  }
//})();
